import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import type { TSelector } from "../../../../../i18n/types";
import DialogueCard from "../../../../../modules/onboarding/components/DialogueCard";
import { AboutQuestion, useSaveOnboardAnswer } from "../../../../../modules/onboarding/components/AboutQuestion";

const USER_TYPE_OPTIONS: { value: string; title?: TSelector; description: TSelector }[] = [
  {
    value: "seller",
    title: ($) => $.onboarding.Seller,
    description: ($) => $.onboarding["I sell on Amazon Marketplace"],
  },
  {
    value: "brand",
    title: ($) => $.onboarding.Brand,
    description: ($) => $.onboarding["I sell on Amazon, Walmart, and other ecommerce platforms"],
  },
  {
    value: "agency",
    title: ($) => $.onboarding.Agency,
    description: ($) => $.onboarding["I work with multiple sellers and brands"],
  },
  {
    value: "aggregator",
    title: ($) => $.onboarding.Aggregator,
    description: ($) => $.onboarding["I acquire brands who sell on Amazon"],
  },
  {
    value: "consultant",
    title: ($) => $.onboarding.Consultant,
    description: ($) => $.onboarding["I work as a consultant to support multiple brands on Amazon"],
  },
  {
    value: "other",
    description: ($) => $.onboarding["I haven't started selling on Amazon"],
  },
];

function AboutTypeStep() {
  const { t } = useTranslation(["onboarding"]);
  const navigate = useNavigate();
  const saveAnswer = useSaveOnboardAnswer({ onSaved: () => void navigate({ to: "/onboarding/v2/about/sales" }) });

  return (
    <AboutQuestion
      prompt={t(($) => $.onboarding["How would you identify your business?"])}
      isSaving={saveAnswer.isPending}
    >
      {USER_TYPE_OPTIONS.map((option) => (
        <DialogueCard
          key={option.value}
          title={option.title ? t(option.title) : ""}
          description={t(option.description)}
          justify="start"
          onPress={() => saveAnswer.mutate({ customer_type: option.value })}
        />
      ))}
    </AboutQuestion>
  );
}

export const Route = createFileRoute("/_authenticated/onboarding/v2/about/type")({
  component: AboutTypeStep,
});
